import { Component, inject, OnInit } from "@angular/core";
import { UpdateNoticeService } from "../service/updatenotice.service";
import { AisProduct } from "src/app/shared/enums/AisProducts";

@Component({
  selector: "app-ais-product-selector",
  standalone: false,

  templateUrl: "./ais-product-selector.component.html",
  styleUrl: "./ais-product-selector.component.scss",
})
export class AisProductSelectorComponent implements OnInit {
  productEnum = AisProduct;

  products = [
    { path: AisProduct.AMDT, label: "AIP Amendment", sub: "Permanent Change", icon: "article" },
    { path: AisProduct.SUP, label: "AIP Supplement", sub: "Temporary Change", icon: "article" },
    { path: AisProduct.NOTAM, label: "NOTAM", sub: "Temporary Change", icon: "notification_important" },
    { path: AisProduct.AIC, label: "AIC", sub: "Permanent or Temporary Change", icon: "article" },
    { path: "not-sure", label: "I Don't Know", sub: "Please guide me", icon: "article" },
  ];

  ngOnInit(): void {}
}
